import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgRelationalDatabaseService = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-relational-database-service';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M9.36 3.353 6.78 4.502l-.01 3.005-.011 3.004-2.249 1-2.25 1v7.018l2.596 1.136c1.428.624 2.617 1.135 2.642 1.135.026 0 1.048-.439 2.272-.975l2.226-.974 2.228.974c1.225.536 2.25.975 2.277.975s1.217-.512 2.644-1.137l2.595-1.137v-7.015l-2.25-1-2.249-1-.011-3.004-.01-3.005-2.58-1.149c-1.419-.632-2.607-1.149-2.64-1.149s-1.221.517-2.64 1.149m4.54 1.313 1.86.827v5.008l-1.05.449-1.049.45-.831-.83-.83-.829-.83.829-.831.83-1.049-.45-1.05-.449V5.493l1.85-.824c1.017-.454 1.872-.826 1.9-.827s.886.37 1.91.824m-5.557 7.513c.433.186.798.348.81.361.013.012-.12.166-.295.342l-.317.319 1.35 1.35L11.24 15.9v2.648l-1.849.809c-1.057.462-1.884.802-1.93.792-.045-.009-.896-.373-1.891-.809l-1.811-.792.011-2.536.01-2.536 1.82-.814c1.001-.448 1.85-.816 1.887-.818s.422.148.856.335m10.038.479 1.839.818.01 2.536.011 2.536-1.85.809c-1.057.462-1.884.802-1.93.792-.045-.009-.895-.373-1.891-.808l-1.81-.793V15.9l1.349-1.349 1.35-1.35-.317-.319c-.175-.176-.308-.33-.295-.342.041-.042 1.572-.695 1.634-.697.033-.002.888.365 1.9.815"
    })
  }));
});
export default SvgRelationalDatabaseService;